package dev.danko.roblox_craft_ai.pages.legal.en

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("legal/en/privacy.md", FrontMatterElement.Builder { addScalar("title", "Privacy Policy"); addScalar("lang", "en"); }))
}

@Page("/legal/en/privacy")
@Layout(".components.layouts.LegalLayout")
@Composable
fun PrivacyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Privacy Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Effective date:")
        }
        org.jetbrains.compose.web.dom.Text(" 3 October 2026")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This policy explains what personal data Craftiva AI (the \"Service\") collects, why, who receives it and what rights you have. The controller of your data is ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("[OPERATOR_NAME]")
        }
        org.jetbrains.compose.web.dom.Text(", [OPERATOR_STATUS], [ADDRESS], [COUNTRY]. Contact for privacy questions: [SUPPORT_EMAIL].")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We collect as little as we need to run the Service. We do not sell personal data, show ads or use analytics or advertising trackers.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("1-data-we-collect") }) {
        org.jetbrains.compose.web.dom.Text("1. Data we collect")
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("What")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Details")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Why")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Account")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Email address, sign-up and last sign-in time, plan and account status")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("To sign you in and provide your account")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Sign-in")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("One-time sign-in links (stored only as a hash, valid 15 minutes, single use); a sign-in cookie")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("To keep you signed in securely")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Guest session")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("A random session token stored in your browser")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("To keep your work if you use the Service without an account")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Access request")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("During the closed beta: email, name, what you want to build, age and privacy confirmations")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("To review requests and tell you when access is open")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Your content")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Prompts, reference images, generated scripts, models and animations, versions and edit requests")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("To generate results and keep your work")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Usage and credits")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Which actions you run, credits spent and bought, estimated provider costs")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("To count credits, enforce limits and prevent abuse")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Payments")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Subscription status, plan, Paddle customer and subscription IDs. Card and billing details are handled by Paddle and never reach us")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("To link your purchases to your account")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Moderation")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("For blocked requests: category, a short excerpt, time and a hashed session ID; reports you send about results")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("To prevent harmful content and abuse")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Technical")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("IP address, browser type, request times; a token that links the Roblox Studio plugin to your session")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Security, rate limiting, troubleshooting and plugin sync")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("In your browser")
        }
        org.jetbrains.compose.web.dom.Text(" we store your language, theme, whether you have seen the welcome tour, and a local cache of your works (localStorage and IndexedDB). This data stays on your device.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("2-legal-bases-eea-uk") }) {
        org.jetbrains.compose.web.dom.Text("2. Legal bases (EEA/UK)")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Contract")
            }
            org.jetbrains.compose.web.dom.Text(": to provide the Service you signed up for, including payments and credits.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Legitimate interests")
            }
            org.jetbrains.compose.web.dom.Text(": to keep the Service secure, moderate content, prevent abuse and fix problems.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Legal obligation")
            }
            org.jetbrains.compose.web.dom.Text(": to keep records required by law.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Consent")
            }
            org.jetbrains.compose.web.dom.Text(": where the law requires it, for example the consent of a parent for users under 16 in the EEA/UK.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("3-who-receives-your-data") }) {
        org.jetbrains.compose.web.dom.Text("3. Who receives your data")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We share data only with providers that help us run the Service:")
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Recipient")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Purpose")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Location")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("[HOSTING_PROVIDER]")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Servers and database")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("[HOSTING_LOCATION]")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Paddle (Paddle.com Market Ltd)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Payments, invoices and taxes as Merchant of Record; Paddle is an independent controller for payment data")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("UK / USA")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Google (Gemini, Imagen)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Generating scripts, text and concept images from your prompt")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("USA / worldwide")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Zhipu AI (GLM)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Generating scripts from your prompt")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("China")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("fal.ai (TRELLIS)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Generating 3D models from concept images")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("USA")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Tripo3D, Meshy")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Generating 3D models (backup providers)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("China, USA")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("[EMAIL_PROVIDER]")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Sending sign-in emails")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("[EMAIL_LOCATION]")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Bunny Fonts, cdnjs (Cloudflare), jsDelivr, esm.sh")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Fonts and code libraries loaded by your browser; they see your IP address")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("EU / worldwide")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("AI providers receive the content of your request (prompt and, for 3D, the image), not your email. Which provider handles a request depends on the action and on availability. Where a provider offers it, we ask it not to store request data (for example, fal.ai requests are sent with storage disabled), and we prefer API options that exclude training on submitted data. Each provider processes data under its own terms and privacy policy.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Some recipients are outside the EEA/UK. Where required, transfers are protected by safeguards such as the European Commission's Standard Contractual Clauses.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may disclose data if required by law or to protect the rights and safety of users and the Service.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("4-how-long-we-keep-data") }) {
        org.jetbrains.compose.web.dom.Text("4. How long we keep data")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Account data and your works: until you delete the work or your account.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Sketches that never became a 3D model: 30 days.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The generator's detailed (source) version of a 3D model: 30 days after it is made; the Roblox version is kept with the work.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Sign-in links: 15 minutes; sign-in cookie: 30 days.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Usage, credit and payment records: up to 3 years after the transaction, longer only if the law requires it. Records of purchased credits are kept while your account exists, because they make up your balance.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Access requests: rejected requests are deleted after 6 months; an approved request becomes part of your account.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Moderation records: up to 12 months.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Server logs: up to 30 days.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Backups: up to 14 days.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When you delete your account, your account, works and files are deleted straight away. Usage and credit records are kept for accounting without any link to you.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("5-children") }) {
        org.jetbrains.compose.web.dom.Text("5. Children")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Service is not intended for children under 13. Children under 13 may use it only together with a parent through the parent's account. In the EEA/UK, users under 16 need a parent's consent. Only adults can make purchases. If you believe a child under 13 has given us personal data without a parent's involvement, contact us and we will delete it.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("6-cookies") }) {
        org.jetbrains.compose.web.dom.Text("6. Cookies")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We use one necessary cookie, ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("rc_auth")
        }
        org.jetbrains.compose.web.dom.Text(", which keeps you signed in (HttpOnly, 30 days). We do not use analytics or advertising cookies, so no cookie banner is needed. When you pay, Paddle's checkout may set its own cookies under Paddle's policy.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("7-security") }) {
        org.jetbrains.compose.web.dom.Text("7. Security")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Connections are encrypted (HTTPS). Sign-in links are stored only as hashes. API keys you save in the Service are encrypted (AES-256-GCM). Access to the admin tools is limited to authorised administrators.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("8-your-rights") }) {
        org.jetbrains.compose.web.dom.Text("8. Your rights")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Depending on where you live, you can ask to access, correct, delete or export your data, restrict or object to processing, and withdraw consent. In ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Settings → Account")
        }
        org.jetbrains.compose.web.dom.Text(" you can download all your data and delete your account yourself at any time. For anything else, write to [SUPPORT_EMAIL] from the email address of your account; we answer within 30 days. You can also complain to your local data protection authority.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("9-changes") }) {
        org.jetbrains.compose.web.dom.Text("9. Changes")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may update this policy. For material changes we will give notice on the site or by email before they take effect.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("10-contact") }) {
        org.jetbrains.compose.web.dom.Text("10. Contact")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("[OPERATOR_NAME], [ADDRESS], [COUNTRY] · [SUPPORT_EMAIL]")
    }
}
